"use client"

import { useState } from "react"
import { ChevronDown } from "lucide-react"
import { ClassCardHeader } from "./class-card-header"
import { ClassCardStats } from "./class-card-stats"
import { ClassCardProgress } from "./class-card-progress"
import { ClassDetailsTabs } from "./class-details-tabs"
import type { ClassData } from "../../../../lib/classes-data"

interface ClassCardProps {
  classData: ClassData
  onViewStudents: (classId: string) => void
}

export function ClassCard({ classData, onViewStudents }: ClassCardProps) {
  const [isOpen, setIsOpen] = useState(false)
  const borderColorClass = classData.borderColor === "primary" ? "border-teal-600" : "border-blue-800"

  return (
    <article
      className={`bg-white rounded-xl shadow-lg border-l-4 ${borderColorClass} overflow-hidden flex flex-col hover:shadow-xl transition-shadow duration-300`}
    >
      <div className="p-6 pb-4">
        <ClassCardHeader classData={classData} />
        <ClassCardStats students={classData.students} avgScore={classData.avgScore} engagement={classData.engagement} />
        <ClassCardProgress
          progress={classData.progress}
          term={classData.term}
          status={classData.status}
          borderColor={classData.borderColor}
        />
      </div>

      <div className="border-t border-gray-100 bg-gray-50 flex-grow flex flex-col">
        <details open={isOpen} className="group flex-grow flex flex-col">
          <summary
            onClick={(e) => {
              e.preventDefault()
              setIsOpen(!isOpen)
            }}
            className="flex justify-between items-center font-medium cursor-pointer list-none p-4 text-teal-600 hover:bg-gray-100 transition"
          >
            <span>View Class Details</span>
            <span className={`transition-transform ${isOpen ? "rotate-180" : ""}`}>
              <ChevronDown className="w-4 h-4" />
            </span>
          </summary>
          {isOpen && <ClassDetailsTabs classData={classData} />}
        </details>

        <div className="p-4 pt-0">
          <button
            onClick={() => onViewStudents(classData.classId)}
            className="w-full py-2 px-4 bg-[#21a193] hover:bg-[#1a8179] text-white font-semibold rounded-lg transition-colors text-sm"
          >
            View Class Details
          </button>
        </div>
      </div>
    </article>
  )
}
